import { Trans, useTranslation } from 'react-i18next';
import classes from './Tabs.module.scss';
import { useEffect, useState } from 'react';

const tabs = [
    {
        title: 'faqs.tabs.tab_01.title',
        acc: [
            {
                subtitle: 'faqs.tabs.tab_01.acc_01.subtitle',
                text: 'faqs.tabs.tab_01.acc_01.text',
            },
            {
                subtitle: 'faqs.tabs.tab_01.acc_02.subtitle',
                text: 'faqs.tabs.tab_01.acc_02.text',
            },
            {
                subtitle: 'faqs.tabs.tab_01.acc_03.subtitle',
                text: 'faqs.tabs.tab_01.acc_03.text',
            },
        ],
    },
    {
        title: 'faqs.tabs.tab_02.title',
        acc: [
            {
                subtitle: 'faqs.tabs.tab_02.acc_01.subtitle',
                text: 'faqs.tabs.tab_02.acc_01.text',
            },
            {
                subtitle: 'faqs.tabs.tab_02.acc_02.subtitle',
                text: 'faqs.tabs.tab_02.acc_02.text',
            },
            {
                subtitle: 'faqs.tabs.tab_02.acc_03.subtitle',
                text: 'faqs.tabs.tab_02.acc_03.text',
            },
            {
                subtitle: 'faqs.tabs.tab_02.acc_04.subtitle',
                text: 'faqs.tabs.tab_02.acc_04.text',
            },
        ],
    },
    {
        title: 'faqs.tabs.tab_03.title',
        acc: [
            {
                subtitle: 'faqs.tabs.tab_03.acc_01.subtitle',
                text: 'faqs.tabs.tab_03.acc_01.text',
            },
            {
                subtitle: 'faqs.tabs.tab_03.acc_02.subtitle',
                text: 'faqs.tabs.tab_03.acc_02.text',
            },
            {
                subtitle: 'faqs.tabs.tab_03.acc_03.subtitle',
                text: 'faqs.tabs.tab_03.acc_03.text',
            },
        ],
    },
    {
        title: 'faqs.tabs.tab_04.title',
        acc: [
            {
                subtitle: 'faqs.tabs.tab_04.acc_01.subtitle',
                text: 'faqs.tabs.tab_04.acc_01.text',
            },
            {
                subtitle: 'faqs.tabs.tab_04.acc_02.subtitle',
                text: 'faqs.tabs.tab_04.acc_02.text',
            },
        ],
    },
    {
        title: 'faqs.tabs.tab_05.title',
        acc: [
            {
                subtitle: 'faqs.tabs.tab_05.acc_01.subtitle',
                text: 'faqs.tabs.tab_05.acc_01.text',
            },
            {
                subtitle: 'faqs.tabs.tab_05.acc_02.subtitle',
                text: 'faqs.tabs.tab_05.acc_02.text',
            },
        ],
    },
];

const Tabs = () => {
    const { t } = useTranslation();
    const [tabActive, setTabActive] = useState(0);
    const [accActive, setAccActive] = useState(0);

    const setAcc = (value) =>
        setAccActive(accActive === value ? -1 : value);

    useEffect(() => {
        setAccActive(0);
    }, [tabActive]);

    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.buttonsWrap}>
                    <div className={classes.num}>
                        <span>0{tabActive + 1} </span>/ 0{tabs.length}
                    </div>
                    <div className={classes.buttons}>
                        {tabs.map((tab, index) =>
                            <div
                                key={index}
                                onClick={() => setTabActive(index)}
                                className={`${classes.button} ${tabActive === index ? classes.active : ''} font-20 no-select`}
                            >
                                {t(tab.title)}
                            </div>
                        )}
                    </div>
                </div>
                <div className={classes.content}>
                    {tabs[tabActive].acc.map((acc, index) =>
                        <div
                            key={index}
                            onClick={() => setAcc(index)}
                            className={`${classes.acc} ${accActive === index ? classes.active : ''} no-select`}
                        >
                            <div className={classes.head}>
                                <h4 className={`${classes.subtitle} font-20`}>
                                    {t(acc.subtitle)}
                                </h4>
                                <div className={classes.status}></div>
                            </div>
                            <p className={`${classes.text} font-16`}>
                                <Trans>
                                    {t(acc.text)}
                                </Trans>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Tabs;
